module.exports = __webpack_public_path__ + "static/media/Ally_app_5.b0d1979d.jpg";